
const createDownloadElement = (fileName, content, type = 'text/csv') => {
  const blob = new Blob([ content ], { type })

  const url = window.URL.createObjectURL(blob)
  const timestamp = new Date().getTime()

  const element = document.createElement('a')
  element.setAttribute('hidden', '')
  element.setAttribute('href', url)
  element.setAttribute('download', `${fileName}_${timestamp}.csv`)

  return element
}

export default createDownloadElement
